module.exports = __webpack_public_path__ + "img/eat_out_15.fae96bc1.jpg";